<template>
   <div>
      <div class="str-rels">
         <OptionalRelationship :data="results.items" :requiredCredits="requiredCredits" :location="location" :conditionSet="cd" :cdLoading="loading" @creditUpdate="updateCredits" @searchOptionalRelationships="getConditionSearch" />
      </div>
      <div v-if="error">
         <div v-if="error.statusCode == 400" class="error">*{{ error.body }}</div>
         <div v-else class="user-info-error course-option-error"><ApiError :error="error.statusCode+' - '+error.body" @errorClicked="closeError" /></div>
      </div>
   </div>
</template>

<script>
   import { mapState, mapActions } from 'vuex'

   import Relationship from './relationship.vue'
   import OptionalRelationship from './optionalRelationship.vue'
   export default {
      components: {
         Relationship,
         OptionalRelationship
      },
      data: function(){
         return {
            results: { items:[] },
            credits: 0,
            size: 0,
            loading: false,
            cd: false,
            error: null,
         }
      },
      mounted: function(){
         if(!this.locked && this.results.items.length == 0 && !this.cd){
            this.loading = true;
            this.error = null;
            this.getConditionSet("condition-set-url="+this.data.query).then(response =>{
               //this.results = response;
               this.getSize(response.links)
               if(this.size <= 2){
                  this.results = response;
                  this.getPage(response.links);
               }else{
                  this.cd = true;
               }
            }).catch(err =>{
               this.error = err;
            }).finally(() =>{
               this.loading = false;
            })
         }
      },
      props: {
         data: {
            type: Object,
            required: true,
         },
         requiredCredits: {
            type: Number,
            required: true
         },
         depth: {
            type: Number,
            required: true,
         },
         location: {
            type: String,
            required: false,
         },
      },
      computed: {
         ...mapState({
            locked: state => state.selections.locked,
            selectedItems: state => state.selections.selectedItems,
         }),
      },
      methods: {
         ...mapActions([
            "getConditionSet",
            "searchConditionSet",
         ]),
         updateCredits(c){
            this.credits = this.credits + c;
         },
         getPage(links){
            if(links.length > 0) {
               let nextLink = links.find(l => l.rel === 'next');
               if(nextLink){
                  this.loading = true;
                  this.error = null;
                  this.getConditionSet(nextLink.href.replace("/api/", "")).then(response => {
                     this.results.items = this.results.items.concat(response.items);
                     this.getPage(response.links);
                  }).catch(err =>{
                     this.error = err;
                  }).finally(() =>{
                     this.loading = false;
                  })
               }
            }
         },
         getSize(links){
            if(links.length > 0) {
               let last = links.find(l => l.rel === 'last');
               if(last){
                  this.size = last.href.substring(last.href.lastIndexOf('=')+1, last.href.length);
               }
            }
         },
         getConditionSearch(input){
            this.loading = true;
            this.error = null;
            if(this.results || val.length == 0){
               this.results.items = this.results.items.filter(x => this.selectedItems.includes(x));
            }else{
               this.results.items = null;
            }
            this.searchConditionSet("condition-set-url="+this.data.query+"&title-or-code-search-term="+input).then(response =>{
               this.results = response;
               this.getPage(response.links);
            }).catch(err =>{
               this.error = err;
            }).finally(() =>{
               this.loading = false;
            })
         },
         closeError(){
            this.error = null;
            this.searchvalue = "";
            this.results = null;
            this.units = null;
         }
      },
      watch: {
         credits: function(newVal, oldVal){
            this.$emit('creditUpdate', newVal-oldVal);
         }
      }
   }
</script>

